import {
  getFavoriteOrgIds,
  getFavoriteOrgsUserId,
} from '@pypestream/design-system';

/**
 * `userDetails.state.settings` is a snapshot loaded once by the user-details
 * page's own GraphQL invoke, never refreshed. On the current user's OWN
 * profile, the Org-menu star (PSTUDIO-3330) writes `favoriteOrgIds` straight
 * to the backend through smartService, instantly and independently of this
 * page's Save button — so saving the stale snapshot as-is can silently
 * revert that write. Re-merge smartService's live value in, but only when
 * this save genuinely targets the logged-in user: `favoriteOrgIds` belongs
 * to the viewer, not to whichever profile happens to be open.
 */
export const resolveSettingsForSave = (
  savedUserId: string,
  settingsSnapshot: Record<string, unknown> | undefined
): Record<string, unknown> =>
  savedUserId === getFavoriteOrgsUserId()
    ? { ...(settingsSnapshot || {}), favoriteOrgIds: getFavoriteOrgIds() }
    : settingsSnapshot || {};
